export default __webpack_public_path__ + "img/benefits2.244ec78a.svg";